import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export const typeMapObj = {
  INCREASE: '增员',
  REDUCE: '减员'
};
const REPLACE = 'REPLACE';
const ADD = 'INCREASE';
const REDUCE = 'REDUCE';
import topTitle from '@/components/title';
export default {
  props: {
    source: {
      type: String,
      default: ''
    },
    headerInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const that = this;
    return {
      // headerInfo: {},
      dataSource: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation',
        width: 100,
        align: 'center'
      }, {
        slots: {
          title: '工种类别'
        },
        dataIndex: 'occupationType',
        key: 'occupationType',
        width: 100,
        align: 'center'
      }, {
        slots: {
          title: '保险方案'
        },
        dataIndex: 'insurancePlanName',
        key: 'insurancePlanName',
        width: 150,
        align: 'center'
      }, {
        slots: {
          title: '劳动合同单位（共同被保险人）'
        },
        dataIndex: 'contractCompany',
        key: 'contractCompany',
        width: 180,
        align: 'center'
      }, {
        slots: {
          title: '实际工作单位（派遣单位）'
        },
        dataIndex: 'dispatchCompany',
        key: 'dispatchCompany',
        width: 180,
        align: 'center'
      }, {
        slots: {
          title: '类型'
        },
        dataIndex: 'recordType',
        key: 'recordType',
        align: 'center',
        width: 110,
        customRender: text => {
          return that.$t(typeMapObj[text]);
        }
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: 'name',
        width: 100,
        align: 'center'
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber',
        width: 200,
        align: 'center'
      }, {
        slots: {
          title: '生效日期'
        },
        dataIndex: 'correctEffectiveAt',
        key: 'correctEffectiveAt',
        align: 'center',
        width: 120
      },
      // {
      //   slots: {title: '保费变化量'},
      //   dataIndex: 'premium',
      //   key: 'premium',
      //   align: 'center',
      //   width: 100
      // },
      {
        slots: {
          title: '备注'
        },
        dataIndex: 'remark',
        key: 'remark',
        align: 'center',
        width: 150,
        ellipsis: true
      }],
      detailObj: {},
      correctEffectiveAt: ''
    };
  },
  computed: {
    isFromGroupInsurance() {
      return this.source === 'groupInsurance';
    }
  },
  watch: {
    headerInfo: {
      handler(val) {
        if (!this.isFromGroupInsurance) {
          this.dataSource = val.correctRecordDetail.personnelList;
          let item = val.correctRecordDetail;
          let detailObj = JSON.parse(val.correctRecordInfo.detail);
          let detailText = detailObj.detail;
          item.detailText = detailText;
          let replaceItems = [];
          let incrementItems = [];
          let reduceItems = [];
          detailObj.safeguard.forEach((item, index) => {
            if (item.type === REPLACE) {
              replaceItems.push(item);
            } else if (item.type === ADD) {
              incrementItems.push(item);
            } else if (item.type === REDUCE) {
              reduceItems.push(item);
            }
          });
          detailObj.replaceItems = replaceItems;
          detailObj.incrementItems = incrementItems;
          detailObj.reduceItems = reduceItems;
          this.detailObj = detailObj;
          this.correctEffectiveAt = val.correctRecordInfo.correctEffectiveAt;
        }
      }
    }
  },
  components: {
    topTitle
  },
  created() {
    // groupInsuranceDetail({auditFlowDetailId: this.$route.params.id}).then(res => {
    //   this.headerInfo = res.baseInfo;
    // });
  },
  methods: {
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
    }
  }
};